import { Component, OnInit } from '@angular/core';
import { SidebarService, AuthService, FirestoreService } from 'src/app/services/service.index';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  user:any;
  toggle_menu: boolean = true;

  ordersTotal:any;
  ordersAsiggned:any;
  ordersPending:any;
  ordersDelivered:any;
  ordersReject:any;

  assigned:any;
  pending:any;
  delivered:any;
  reject:any;

  constructor(public _sidebar: SidebarService, public authService: AuthService, private afs: FirestoreService) {

   }



    ngAfterViewInit() {





     }

  ngOnInit(): void {

    this.user = this.afs.usersShow;


    if(this.user.companyId == undefined || this.user.companyId == ''){
        //console.log(this.user.companyId);
    }else{
       this._sidebar.showMenu();

       let datestart = new Date(new Date().setHours(0, 0, 0, 0)).getTime();

       this.afs.getAllOrdersGraphics(this.user.companyId, datestart).subscribe(orders => {


             this.ordersTotal = orders.length;

             //console.log(this.ordersTotal);

       });

       this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 0).subscribe(orders => {


        this.ordersPending = orders.length;

        this.pending = (this.ordersPending * 100) / this.ordersTotal;

      });

       this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 1).subscribe(orders => {


           this.ordersAsiggned = orders.length;


           this.assigned = (this.ordersAsiggned * 100) / this.ordersTotal;

      });

      this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 2).subscribe(orders => {


        this.ordersDelivered = orders.length;


        this.delivered = (this.ordersDelivered * 100) / this.ordersTotal;

   });

   this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 3).subscribe(orders => {


    this.ordersReject = orders.length;


    this.reject = (this.ordersReject * 100) / this.ordersTotal;

});

    }
  }

}
